import { makeStyles, createStyles } from '@material-ui/core/styles'

import { Theme } from '~/theme/theme'

export const useCategoryFilterFieldStyles = makeStyles(
  (theme: Theme) =>
    createStyles({
      root: {
        '& *::-webkit-scrollbar': {
          width: '10px'
        },
        '& .MuiAutocomplete-option': {
          display: 'block',
          '& *::-webkit-scrollbar': {
            width: '6px'
          },
          '& .MuiListItem-gutters p': {
            fontSize: 16,
            fontFamily: 'Nunito Sans, sans-serif',
            fontWeight: 400,
            lineHeight: 1.5,
            color: theme.palette.text.primary
          },
          '& .MuiAutocomplete-paper': {
            marginTop: 0,
            marginBottom: 0,
            paddingRight: '4px'
          },
          '& .MuiListItem-gutters > svg': {
            color: `${theme.palette.text.primary} !important`
          }
        },
        '& .MuiButtonBase-root.MuiListItem-dense': {
          paddingRight: '24px'
        }
      }
    }),
  { name: 'CategoryFilterField' }
)
